import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";

const Setftestexammodule = ({ questions, testid, userid }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showAnswer, setShowAnswer] = useState(false);
  const [finish, setFinish] = useState(false);
  const [score, setScore] = useState(0);

  // safety check
  if (!questions || questions.length === 0) {
    return (
      <>
        <Clienthomemenu title="EasyITI" testhistory="testhistory" />
        <div className="container text-center mt-5">
          <h5>Loading questions...</h5>
        </div>
      </>
    );
  }

  const currentQ = questions[currentIndex];

  /* ================= OPTION CLICK ================= */
  const selectOption = (opt) => {
    if (showAnswer || finish) return;

    const isCorrect = opt === currentQ.RIGHT_ANS;

    setAnswers((prev) => ({
      ...prev,
      [currentQ.QUE_UID]: opt,
    }));

    if (isCorrect) {
      setScore((prev) => prev + 1);
    }

    setShowAnswer(true);

    // auto next after 1 second
    setTimeout(() => {
      setShowAnswer(false);

      if (currentIndex < questions.length - 1) {
        setCurrentIndex((prev) => prev + 1);
      } else {
        setFinish(true);
      }
    }, 1000);
  };

  /* ================= RESULT ================= */
  if (finish) {
    return (
      <>
        <Clienthomemenu title="EasyITI" testhistory="testhistory" />

        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div className="card p-4 shadow text-center" style={{ maxWidth: 400 }}>
            <h3 className="text-success mb-3">Self Test Result 🎯</h3>

            <p>Total Questions : {questions.length}</p>
            <p className="fw-bold fs-5">
              Score : {score} / {questions.length}
            </p>

            <button
              className="btn btn-primary mt-3"
              onClick={() => window.location.reload()}
            >
              Restart Test 🔄
            </button>
          </div>
        </div>
      </>
    );
  }

  /* ================= EXAM UI ================= */
  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      <div className="container vh-100 d-flex justify-content-center align-items-center">
        <div className="card w-100 shadow" style={{ maxWidth: 700 }}>
          <div className="card-header bg-primary text-white">
            Question {currentIndex + 1} / {questions.length}
          </div>

          <div className="card-body">
            <h5 className="mb-4">{currentQ.QUESTION}</h5>

            {["A", "B", "C", "D"].map((opt, i) => {
              let cls = "border p-3 rounded mb-2";

              if (showAnswer) {
                if (opt === currentQ.RIGHT_ANS) {
                  cls += " bg-success text-white";
                } else if (answers[currentQ.QUE_UID] === opt) {
                  cls += " bg-danger text-white";
                }
              }

              return (
                <div
                  key={opt}
                  className={cls}
                  onClick={() => selectOption(opt)}
                  style={{ cursor: "pointer" }}
                >
                  {opt}. {currentQ[`OPT${i + 1}`]}
                </div>
              );
            })}
          </div>

          <div className="card-footer text-muted text-end">
            Score : {score}
          </div>
        </div>
      </div>
    </>
  );
};

export default Setftestexammodule;
